import React from "react";

const tone = (ms) => (ms == null ? "#ef4444" : Math.abs(ms) <= 70 ? "#10b981" : Math.abs(ms) <= 140 ? "#f59e0b" : "#ef4444");

// After a try: every note's beat (circle) next to the learner's clap (diamond), plus a rushing/dragging summary.
export const ClapTimeline = ({ expected, offsets, extras = [], totalMs, beatMs, testId, micAdjusted }) => {
  const W = 600, pad = 14, x = (ms) => pad + (Math.max(0, Math.min(totalMs, ms)) / totalMs) * (W - pad * 2);
  const hit = offsets.filter((o) => o != null);
  const avg = hit.length ? Math.round(hit.reduce((a, b) => a + b, 0) / hit.length) : 0;
  const summary = !hit.length ? "No claps lined up with the notes this time."
    : Math.abs(avg) <= 30 ? "Your timing was nicely centred on the beat."
      : avg > 0 ? `On average you were ${avg} ms late, so you're dragging a little. Try to clap right on the beat.`
        : `On average you were ${-avg} ms early, so you're rushing a little. Wait for the beat.`;
  const beats = Math.round(totalMs / beatMs);
  return (
    <div className="mt-3 rounded-xl border border-border bg-background/60 p-3" data-testid={`${testId}-timeline`}>
      <p className="text-xs font-semibold">Your claps compared with the beat</p>
      <svg viewBox={`0 0 ${W} 64`} className="mt-1 w-full" role="img" aria-label="Clap timing timeline">
        <line x1={pad} x2={W - pad} y1="32" y2="32" stroke="currentColor" strokeOpacity="0.3" />
        {Array.from({ length: beats + 1 }, (_, b) => <line key={b} x1={x(b * beatMs)} x2={x(b * beatMs)} y1="20" y2="44" stroke="currentColor" strokeOpacity="0.18" />)}
        {expected.map((e, i) => (
          <g key={i} data-testid={`${testId}-timeline-note-${i}`} data-offset={offsets[i] ?? "missed"}>
            <circle cx={x(e)} cy="20" r="5" fill="none" stroke="currentColor" strokeWidth="1.5" />
            {offsets[i] != null ? (
              <>
                <line x1={x(e)} x2={x(e + offsets[i])} y1="32" y2="32" stroke={tone(offsets[i])} strokeWidth="3" />
                <rect x={x(e + offsets[i]) - 5} y="39" width="10" height="10" transform={`rotate(45 ${x(e + offsets[i])} 44)`} fill={tone(offsets[i])} />
              </>
            ) : <text x={x(e)} y="52" textAnchor="middle" fontSize="12" fill="#ef4444">×</text>}
          </g>
        ))}
        {extras.map((t, i) => <circle key={`x${i}`} cx={x(t)} cy="44" r="3" fill="currentColor" fillOpacity="0.35" />)}
      </svg>
      <p className="text-[11px] text-muted-foreground">○ = the note · ◆ = your clap (green on time, amber close, red off) · × = missed · grey dot = extra sound</p>
      <p className="mt-1 text-xs font-medium" data-testid={`${testId}-timeline-summary`}>{summary}</p>
      {micAdjusted && <p className="text-[11px] text-muted-foreground" data-testid={`${testId}-timeline-mic-note`}>With the microphone, the device's steady delay is taken out first, so this shows how even your claps were. Use tapping to check whether you rush or drag overall.</p>}
    </div>
  );
};
